<template>
  <div id="app">
    <HeaderBox></HeaderBox>
    <div class="content">
      <router-view />
    </div>
    <FooterBox></FooterBox>
  </div>
</template>
<script>
import HeaderBox from '../src/components/header.vue';
import FooterBox from '../src/components/footer.vue';
export default {
  props: {
    msg: String
  },
  components: {
    HeaderBox,
    FooterBox
  },
  data() {
    return {
      activeIndex: '1',
    };
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped></style>
